import { render, staticRenderFns } from "./ContractForm.vue?vue&type=template&id=1070ceb8"
import script from "./ContractForm.vue?vue&type=script&lang=js"
export * from "./ContractForm.vue?vue&type=script&lang=js"
import style0 from "./ContractForm.vue?vue&type=style&index=0&id=1070ceb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports